import React from "react";
import products from "../../consts/products";
import { ProductsContext } from "../../context/ProductsContext";
import bg_video from "../../dist/img/Flowdia_Q_BG_movie.mov";
import { useLocation, Link } from "react-router-dom";
const Question5 = ({ deleteStep , setAnswer5, addStep }) => {
  const { p2 } = React.useContext(ProductsContext);
  const [product2, setProduct2] = p2;

  const answerHandler = (option) => {
    setAnswer5(option);
    addStep();
    product2Handler(option);
  };

  const product2Handler = (answer5) => {
    let result = "";
    switch (answer5) {
      case "option1":
        result = "E";
        break;
      case "option2":
        result = "F";
        break;
      case "option3":
        result = "G";
    }
    const product = products.find((p) => p.id === result);
    setProduct2(product);
  };

  return (
    <section className="c-question">
      <video poster="" autoPlay loop playsInline>
        <source src={bg_video} type="video/mp4"></source>
      </video>

      <section className="c-question__progress">
        <dl>
          <dt>QUESTION</dt>
          <dd>
            6 / <span>14</span>
          </dd>
        </dl>
      </section>

      <section className="c-question__content p-question__content p-question__content--5 c-box2">
        <h1 className="c-question__title">一番かなえたいケア効果は？</h1>
        <section
          onClick={() => answerHandler("option1")}
          className="c-question__option p-question__option p-question__option--5"
        >
          <p>
            ・トップにボリュームを出したい
            <br />
            ・髪をしっかりさせたい
          </p>
        </section>
        <section
          onClick={() => answerHandler("option2")}
          className="c-question__option p-question__option p-question__option--5"
        >
          <p>
            ・ヘアカラーを長持ちさせたい
            <br />
            ・ヘアカラーダメージをケアしたい
          </p>
        </section>
        <section
          onClick={() => answerHandler("option3")}
          className="c-question__option p-question__option p-question__option--5"
        >
          <p>
            ・乾燥している髪にうるおいを与えたい
            <br />
            ・パサつきと広がりをおさえたい
          </p>
        </section>
        <Link style ={{  margin: "25px auto"}} onClick={() => deleteStep()}  className="c-question__btn2 p-output__btn--v2">
          BACK
        </Link>
      </section>
    </section>
  );
};

export default Question5;
